import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { deleteBuildingById } from "../../services/api/building";
import { showToast } from "../../store/slices/toastSlice";
import CloseIcon from "@mui/icons-material/Close";
import { DELETE_BUTTON, RESET_CANCEL_BUTTON } from "../../styles/ButtonStyles";

const DeleteBuildingDialog = ({ open, onClose, buildingId, onSuccess }) => {
  const dispatch = useDispatch();

  const handleConfirmDelete = async () => {
    try {
      const res = await deleteBuildingById(buildingId);
      if (res.responseCode === 200) {
        dispatch(showToast({ message: res.message, severity: "success" }));
        onSuccess(); // Reload or update state from parent
      }
    } catch (error) {
      dispatch(showToast({ message: error.message, severity: "error" }));
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ backgroundColor: "#eeaaaaff" }}>
        Are you sure you want to delete this building?
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>

      <Divider />

      <DialogContent sx={{ backgroundColor: "#f9f9f9" }}>
        Deleting this building will permanently remove it from the inventory,
        along with all associated references. <br />
        <br />
        This action cannot be undone. Please make sure you want to proceed
        before confirming.
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button onClick={onClose} sx={RESET_CANCEL_BUTTON}>
          Cancel
        </Button>
        <Button onClick={handleConfirmDelete} sx={DELETE_BUTTON}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBuildingDialog;
